import routerInstance from './routerInstance';

export const generateUrl = (name: string, params?: Record<string, unknown>): string =>
  routerInstance.generate(name, params);

export default routerInstance;
